// Lint exception: We want to log messages
import type { Configuration } from "@azure/msal-browser";

import { env } from "../../utils/env.js";

const MSAL_WARN_LEVEL = 1;
const MSAL_INFO_LEVEL = 2;
const MSAL_DEBUG_LEVEL = 3;

/**
 * MSAL configuration for authentication
 */
export const interactiveRedirectUri =
  env.PUBLIC_FRONTEND_URL || window.location.origin;

export const silentRedirectUri = new URL(
  "silent-auth-callback.html",
  `${interactiveRedirectUri.replace(/\/$/u, "")}/`
).toString();

export const msalConfig: Configuration = {
  auth: {
    authority: "https://login.microsoftonline.com/common",
    clientId: env.PUBLIC_CLIENT_ID,
    postLogoutRedirectUri: interactiveRedirectUri,
    redirectUri: interactiveRedirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      logLevel: 2,
      loggerCallback: (
        level: number,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case MSAL_WARN_LEVEL: {
            console.warn("MSAL:", message);
            break;
          }
          case MSAL_INFO_LEVEL: {
            console.info("MSAL:", message);
            break;
          }

          case MSAL_DEBUG_LEVEL: {
            console.debug("MSAL:", message);
            break;
          }
          default: {
            console.error("MSAL:", message);
            break;
          }
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [`${env.PUBLIC_SCOPE}/access_as_user`],
};

export const graphRequest = {
  scopes: ["User.Read", "TeamMember.Read.All", "Team.ReadBasic.All"],
};
